import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia'

const app = createApp();
const pinia = createPinia();

app.use(pinia);

app.config.compilerOptions.nativeTemplate = false;
app.config.compilerOptions.whitespace = 'preserve';

// Define asynchronous components
const asyncComponents = {
    SiteHeader: defineAsyncComponent(() => import(/* webpackPrefetch: true, webpackChunkName: 'SiteHeader' */ './components/SiteHeader.vue')),
    BlogList: defineAsyncComponent(() => import(/* webpackChunkName: 'BlogList' */ './components/BlogList.vue')),
    AccordionItem: defineAsyncComponent(() => import(/* webpackChunkName: 'AccordionItem' */ './components/AccordionItem.vue')),
    TypeWriter: defineAsyncComponent(() => import(/* webpackChunkName: 'TypeWriter' */ './components/TypeWriter.vue')),
    DynamicModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'DynamicModalButton' */ './components/DynamicModalButton.vue')),
    InfoTip: defineAsyncComponent(() => import(/* webpackChunkName: 'InfoTip' */ './components/InfoTip.vue')),
    ProductConfigurator: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductConfigurator' */ './components/commerce/ProductConfigurator.vue')),
    SearchResults: defineAsyncComponent(() => import(/* webpackChunkName: 'SearchResults' */ './components/SearchResults.vue')),
    TruncatedText: defineAsyncComponent(() => import(/* webpackChunkName: 'TruncatedText' */ './components/TruncatedText.vue')),
    TruncatedBlock: defineAsyncComponent(() => import(/* webpackChunkName: 'TruncatedBlock' */ './components/TruncatedBlock.vue')),
    HeroCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'HeroCarousel' */ './components/HeroCarousel.vue')),
    ModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'ModalButton' */ './components/ModalButton.vue')),
    TabsWrapper: defineAsyncComponent(() => import(/* webpackChunkName: 'TabsWrapper' */ './components/TabsWrapper.vue')),
    Tab: defineAsyncComponent(() => import(/* webpackChunkName: 'Tab' */ './components/Tab.vue')),
    SocialShare: defineAsyncComponent(() => import(/* webpackChunkName: 'SocialShare' */ './components/SocialShare.vue')),
    ProductGallery: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductGallery' */ './components/ProductGallery.vue')),
    ProductCardCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductCardCarousel' */ './components/ProductCardCarousel.vue')),
    CardCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'CardCarousel' */ './components/CardCarousel.vue')),
    AddToBasketModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'AddToBasketModalButton' */ './components/commerce/AddToBasketModalButton.vue')),
};

// Register components asynchronously
for (const [componentName, asyncComponent] of Object.entries(asyncComponents)) {
    app.component(componentName, asyncComponent);
}

app.mount('#app');